import BusinessRepository from '@/business/modules/business/business.repository';
import type {
	ISendSmsRequest,
	IRequestValidateBusiness,
	IRegisterBusinessRequest,
	IRegisterBusinessResponse,
	IGetBusinessInformationResponse,
	IInquiryBusinessResponse,
	IParamsSearchOnBusiness,
	IParamsGetUsers,
	IAssignBusinessCategoriesRequest,
	IVerifyBusiness,
	ICreateCustomerRequest,
	ICustomerClubDashboardParams,
	IUpdateBusinessProfileRequest,
	IParamsGetBusinessesByCity,
	IRecordBusinessProfileContactRequest,
} from '@/business/modules/business/business.model';
import { CategoryMapper } from '@/business/core/mappers/category';

class BusinessService {
	static #instance: BusinessService;
	private readonly repository;

	private constructor() {
		this.repository = BusinessRepository.getInstance();
	}

	public static getInstance(): BusinessService {
		if (!BusinessService.#instance) {
			BusinessService.#instance = new BusinessService();
		}

		return BusinessService.#instance;
	}

	async inquiryBusiness(): Promise<IInquiryBusinessResponse> {
		// await new Promise((resolve) => setTimeout(resolve, 3000));
		return this.repository.inquiryBusiness();
	}

	singupAsBusiness(data: IRegisterBusinessRequest): Promise<IRegisterBusinessResponse> {
		return this.repository.singupAsBusiness(data);
	}

	getBusinessInformation(id: string): Promise<IGetBusinessInformationResponse> {
		return this.repository.getBusinessInformation(id);
	}

	getBusinessProfileBySlug(citySlug: string, businessSlug: string): Promise<IGetBusinessInformationResponse> {
		return this.repository.getBusinessProfileBySlug(citySlug, businessSlug);
	}

	recordProfileContact(data: IRecordBusinessProfileContactRequest) {
		return this.repository.recordProfileContact(data);
	}

	updataBusinessProfile(data: IUpdateBusinessProfileRequest) {
		return this.repository.updataBusinessProfile(data);
	}

	requestValidateBusiness(data: IRequestValidateBusiness) {
		return this.repository.requestValidateBusiness(data);
	}

	searchOnBusiness(params: IParamsSearchOnBusiness) {
		return this.repository.searchOnBusiness(params);
	}

	async getBusinessesByCity(params: IParamsGetBusinessesByCity) {
		const response = await this.repository.getBusinessesByCity(params);
		const list = Array.isArray(response?.data?.data) ? response.data.data : [];
		const mapped = CategoryMapper.formatCategoryList(list);

		return { ...response, data: { ...response.data, data: mapped } };
	}

	sendSms(data: ISendSmsRequest) {
		return this.repository.sendSms(data);
	}

	getCustomerClubDashboard(params?: ICustomerClubDashboardParams) {
		return this.repository.getCustomerClubDashboard(params);
	}

	submitRating(data: any) {
		return this.repository.submitRating(data);
	}

	makeUserVIP(userId) {
		return this.repository.makeUserVIP(userId);
	}

	makeUserNormal(userId) {
		return this.repository.makeUserNormal(userId);
	}

	createCustomer(data: ICreateCustomerRequest) {
		return this.repository.createCustomer(data);
	}

	getNormalUser(params: IParamsGetUsers) {
		return this.repository.getNormalUser(params);
	}

	getVIPUser(params: IParamsGetUsers) {
		return this.repository.getVIPUser(params);
	}

	getPendingBusinesses(params) {
		return this.repository.getPendingBusinesses(params);
	}

	assignCategoriesToBusiness(data: IAssignBusinessCategoriesRequest) {
		return this.repository.assignCategoriesToBusiness(data);
	}

	getCategoriesOfBusiness(businessId: string) {
		return this.repository.getCategoriesOfBusiness(businessId);
	}

	verifyBusiness(params: IVerifyBusiness) {
		return this.repository.verifyBusiness(params);
	}

	updateReserveTimePayment(enabled: boolean) {
		return this.repository.updateReserveTimePayment(enabled);
	}

	updateOnlineReservation(enabled: boolean) {
		return this.repository.updateOnlineReservation(enabled);
	}

	updateCancellationPolicy(data) {
		return this.repository.updateCancellationPolicy(data);
	}

	createSlotTime(data) {
		return this.repository.createSlotTime(data);
	}
}

export default BusinessService;
